const empty = () =>
  import(/* webpackChunkName: "empty" */ "../views/Empty.vue");

const courseList = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/CourseList.vue");
const courseEdit = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/CourseEdit.vue");
const coursePlan = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/CoursePlan.vue");
const courseChapter = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/CourseChapter.vue");
const courseCatagory = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/CourseCatagory.vue");

const courseValidityList = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/user/CourseValidity/CourseValidity.vue"
  );
const courseValidityEdit = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/user/CourseValidity/CourseValidityEdit.vue"
  );
const enrollmentList = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/Enrollments.vue");
const enrollmentEdit = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/EnrollmentsEdit.vue");

const otoSetting = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/TeachOtoSetting.vue");
const otoLevel = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/TeachOtoLevel.vue");
const otoSchedule = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/TeachOtoSchedule.vue");
const otoScheduleDetail = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/teach/TeachOtoScheduleDetail.vue"
  );
const otoTag = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/TeachOtoTag.vue");
const otoAppoint = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/TeachOtoAppoint.vue");
const otoCommunication = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/teach/TeachOtoCommunication.vue"
  );
const otoComment = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/TeachOtoComment.vue");

const otoTable = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/TeachOtoTable.vue");

const ClassManage = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/ClassManage.vue");
const ClassEdit = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/ClassEdit.vue");
const StudentList = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/StudentList.vue");
const HomeworkList = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/HomeworkList.vue");
const ClassGradeStudent = () =>
  import(/* webpackChunkName: "teach" */ "../views/Imports");
const StudentOrderList = () =>
  import(/* webpackChunkName: "teach" */ "../views/finance/Order");
const StudentRecordList = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/statistics/StatisticsStudent"
  );
const StudentHomeworkList = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/teach/StudentHomeworkList.vue"
  );
const StudentHomeworkStatis = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/teach/StudentHomeworkStatis.vue"
  );
const StudentHomeworkPreview = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/teach/StudentHomeworkPreview.vue"
  );
const StudentHomeworkApprove = () =>
  import(
    /* webpackChunkName: "teach" */ "../views/teach/StudentHomeworkApprove.vue"
  );
const HomeworkManage = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/HomeworkManage.vue");
const HomeworkStatis = () =>
  import(/* webpackChunkName: "teach" */ "../views/teach/HomeworkStatis.vue");

export default [
  {
    path: "teach",
    name: "Teach",
    component: empty,
    children: [
      {
        path: "course",
        name: "Course",
        component: empty,
        meta: {
          title: "课程管理",
        },
        children: [
          {
            path: "manage",
            name: "CourseManage",
            component: courseList,
            meta: {
              title: "课程管理",
              keepAlive: true,
              root: true,
            },
          },
          {
            path: "edit",
            name: "CourseEdit",
            component: courseEdit,
            meta: {
              title: "课程新增/编辑",
            },
          },
          {
            path: "plan",
            name: "CoursePlan",
            component: coursePlan,
            meta: {
              title: "大纲管理",
            },
          },
          {
            path: "chapter",
            name: "CourseChapter",
            component: courseChapter,
            meta: {
              title: "新增/编辑课时",
            },
          },
          {
            path: "catagory",
            name: "CourseCatagory",
            component: courseCatagory,
            meta: {
              title: "课程分类",
              root: true,
            },
          },
        ],
      },
      {
        path: "course_validity",
        name: "CourseValidityManage",
        component: courseValidityList,
        meta: {
          title: "课程有效期管理",
          keepAlive: true,
          root: true,
        },
      },
      {
        path: "course_validity_edit",
        name: "CourseValidityEdit",
        component: courseValidityEdit,
        meta: {
          title: "课有效期新增/编辑",
        },
      },
      {
        path: "enrollments",
        name: "Enrollments",
        component: enrollmentList,
        meta: {
          title: "学藉信息管理",
          keepAlive: true,
          root: true,
        },
      },

      {
        path: "enrollments_edit",
        name: "EnrollmentsEdit",
        component: enrollmentEdit,
        meta: {
          title: "学藉信息编辑",
          keepAlive: true,
          root: true,
        },
      },

      {
        path: "oto",
        name: "oto",
        component: empty,
        meta: {
          title: "一对一",
        },
        children: [
          {
            path: "schedule",
            name: "TeachOtoSchedule",
            component: otoSchedule,
            meta: {
              title: "排课管理",
              root: true,
            },
          },
          {
            path: "schedule-detail",
            name: "TeachOtoScheduleDetail",
            component: otoScheduleDetail,
            meta: {
              title: "讲师排课",
            },
          },
          {
            path: "level",
            name: "TeachOtoLevel",
            component: otoLevel,
            meta: {
              title: "讲师等级设置",
              root: true,
            },
          },
          {
            path: "setting",
            name: "TeachOtoSetting",
            component: otoSetting,
            meta: {
              title: "预约项设置",
              root: true,
            },
          },
          {
            path: "tag",
            name: "TeachOtoTag",
            component: otoTag,
            meta: {
              title: "标签设置",
              root: true,
            },
          },
          {
            path: "appoint",
            name: "TeachOtoAppoint",
            component: otoAppoint,
            meta: {
              title: "约课管理",
              root: true,
            },
          },
          {
            path: "communication",
            name: "TeachOtoCommunication",
            component: otoCommunication,
            meta: {
              title: "沟通记录",
            },
          },
          {
            path: "comment",
            name: "TeachOtoComment",
            component: otoComment,
            meta: {
              title: "互评",
            },
          },
        ],
      },
      {
        path: "table",
        name: "TeachOtoTable",
        component: otoTable,
        meta: {
          title: "课程表",
          root: true,
        },
      },
      {
        path: "class-manager",
        name: "ClassManage",
        component: ClassManage,
        meta: {
          title: "班级管理",
          root: true,
        },
      },
      {
        path: "class-edit",
        name: "ClassEdit",
        component: ClassEdit,
        meta: {
          title: "新增/编辑班级",
        },
      },
      {
        path: "student-list",
        name: "StudentList",
        component: StudentList,
        meta: {
          title: "学员列表",
        },
      },
      {
        path: "homework-list",
        name: "HomeworkList",
        component: HomeworkList,
        meta: {
          title: "作业列表",
        },
      },
      {
        path: "student/order",
        name: "StudentOrderList",
        component: StudentOrderList,
        meta: {
          title: "查看订单",
        },
      },
      {
        path: "student/record",
        name: "StudentRecordList",
        component: StudentRecordList,
        meta: {
          title: "学习记录",
        },
      },
      {
        path: "student/homework",
        name: "StudentHomeworkList",
        component: StudentHomeworkList,
        meta: {
          title: "学员作业列表",
        },
      },
      {
        path: "student/homework/statis",
        name: "StudentHomeworkStatis",
        component: StudentHomeworkStatis,
        meta: {
          title: "答题统计",
        },
      },
      {
        path: "student/homework/preview",
        name: "StudentHomeworkPreview",
        component: StudentHomeworkPreview,
        meta: {
          title: "预览",
        },
      },
      {
        path: "student/homework/approve",
        name: "StudentHomeworkApprove",
        component: StudentHomeworkApprove,
        meta: {
          title: "详情",
        },
      },
      {
        path: "class-grade-student",
        name: "ClassGradeStudent",
        component: ClassGradeStudent,
        meta: {
          title: "批量导入",
        },
      },
      {
        path: "homework/manage",
        name: "HomeworkManage",
        component: HomeworkManage,
        meta: {
          title: "作业管理",
          root: true,
        },
      },
      {
        path: "homework/preview",
        name: "HomeworkPreview",
        component: StudentHomeworkPreview,
        meta: {
          title: "预览",
        },
      },
      {
        path: "homework/statis",
        name: "HomeworkStatis",
        component: HomeworkStatis,
        meta: {
          title: "作业统计",
        },
      },
      {
        path: "homework/approve",
        name: "HomeworkApprove",
        component: StudentHomeworkApprove,
        meta: {
          title: "详情",
        },
      },
      {
        path: "homework/statis-answer",
        name: "HomeworkStatisAnswer",
        component: StudentHomeworkStatis,
        meta: {
          title: "答题统计",
        },
      },
      {
        path: "homework/statis/preview",
        name: "HomeworkStatisPreview",
        component: StudentHomeworkPreview,
        meta: {
          title: "预览",
        },
      },
    ],
  },
];
